import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-48c052cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "related" }
const _hoisted_2 = { class: "body" }
const _hoisted_3 = { class: "title-section-spacing" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "font-bold block text-left" }, "Documenti associati", -1))
const _hoisted_5 = { class: "related-documents w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DocumentCard = _resolveComponent("DocumentCard")!
  const _component_AddEditDocumentModalDialog = _resolveComponent("AddEditDocumentModalDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "add-document text-primary block float-right",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isShowingDocumentDialog = true))
          }, "Aggiungi documento"),
          _hoisted_4
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (doc) => {
            return (_openBlock(), _createBlock(_component_DocumentCard, {
              "model-value": doc,
              "is-document-to-be-approved": false,
              scope: _ctx.scope,
              "working-site-id": _ctx.workingSiteId,
              "user-id": _ctx.userId,
              "communication-id": _ctx.communicationId,
              tags: {}
            }, null, 8, ["model-value", "scope", "working-site-id", "user-id", "communication-id"]))
          }), 256))
        ])
      ])
    ]),
    (_ctx.isShowingDocumentDialog)
      ? (_openBlock(), _createBlock(_component_AddEditDocumentModalDialog, {
          key: 0,
          onClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isShowingDocumentDialog = false)),
          scope: _ctx.scope,
          "working-site-id": _ctx.workingSiteId,
          "user-id": _ctx.userId,
          "communication-id": _ctx.communicationId
        }, null, 8, ["scope", "working-site-id", "user-id", "communication-id"]))
      : _createCommentVNode("", true)
  ], 64))
}